import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import styles from '../../../css/paymentPage/subComponents/ToastPaymentComponent.scss';
import { getCurrentOrder } from '../../../selectors';
import * as Config from '../../../../config.json';

const userHeader = { 'Content-Type': 'application/json' };
const companyHeader = { 'Content-Type': 'application/json', Authorization: `Bearer ${Config.general.apiKey}` };

const responsiveStyles = typeof styles === 'function' ? styles() : styles;

class ToastPaymentComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      htmlContent: '',
    };
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    window.addEventListener('message', this.handleIframeTask);
    this.getHtmlContent();
  }

  getHtmlContent = async () => {
    const { actions, user } = this.props;
    const response = await actions.getOfflineResource(user.token, ['toast-payment', 'web']);
    // We 'manually' insert the HTML we got from API into our iframe.
    // eslint-disable-next-line no-undef
    const iframe = document.getElementById('toastWebForm');
    const iframedoc = iframe.contentWindow.document || iframe.contentDocument;
    iframedoc.open();
    iframedoc.write(response.data);
    iframedoc.close();
  }

  handleIframeTask = (event) => {
    if (event && event.data && event.data.source === 'toastForm') {
      const eventResponseData = event.data.data;
      if (event.data.status !== 500 && eventResponseData) {
        // let the parent component handle a newly added card.
        if (this.props.handleAddCard) {
          this.props.handleAddCard(eventResponseData);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.frameContainer}>
        <iframe
          id="toastWebForm"
          title="toast"
          frameBorder="0"
          height="100%"
          width="100%"
        />
      </div>
    );
  }
}

ToastPaymentComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  handleAddCard: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  currentOrder: getCurrentOrder(state),
});

export default connect(mapStateToProps)(withStyles(responsiveStyles)(ToastPaymentComponent));
